const defaultConfigName = 'global-pro';
//const defaultConfigName = 'global-test';
module.exports = defaultConfigName;
